/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:cd318aaf-abdb-4bb0-99c0-d98529a5893b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_H927AOJ3C",
    "aws_user_pools_web_client_id": "65eb0mhdgdc2m4e92ccbtoigr4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "ompreortal-20200429221131-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://ompreortal-20200429221131-hostingbucket-dev.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
